module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "projects"
  }, _vm._l((_vm.projects), function(p) {
    return _c('div', {
      staticClass: "project panel"
    }, [_c('h3', {
      staticClass: "project-title title"
    }, [_vm._v(_vm._s(p.title))]), _vm._v(" "), _c('p', {
      staticClass: "project-bio"
    }, [_vm._v(_vm._s(p.bio))]), _vm._v(" "), (p.link) ? _c('a', {
      staticClass: "project-link",
      attrs: {
        "href": p.link
      }
    }, [_vm._v(_vm._s(p.link))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "project-badges"
    }), _vm._v(" "), (p.img) ? _c('div', {
      staticClass: "project-image"
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": p.img
      }
    })]) : _vm._e()])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Project")]), _vm._v(" "), _c('h2', [_vm._v("Do some cool stuff")]), _vm._v(" "), _c('h2', [_vm._v("做一点微小的贡献")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "links"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://geekplux.com/archives"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://geekplux.com/wiki"
    }
  }, [_vm._v("Wiki")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/geekplux"
    }
  }, [_vm._v("GitHub")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://about.geekplux.com"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://donate.geekplux.com"
    }
  }, [_vm._v("Donate")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d57b0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./App.vue
// module id = 5
// module chunks = 0